// import axios from "axios";
// import React, { useState } from "react";
// import { Link, useNavigate } from "react-router-dom";
// import { toast, ToastContainer } from "react-toastify";
// import "react-toastify/dist/ReactToastify.css";
// // import "./SellerRegistration.css";

// const SellerRegistration = () => {
//   const navigate = useNavigate();
//   const [formData, setFormData] = useState({
//     business_name: "",
//     owner_name: "",
//     email: "",
//     mobile: "",
//     password: "",
//     confirm_password: "",
//     gst_number: "",
//     pan_number: "",
//     address: "",
//     city: "",
//     state: "",
//     pincode: "",
//     bank_account_number: "",
//     bank_ifsc_code: "",
//     bank_account_holder: "",
//     business_type: "individual",
//     category: "",
//   });

//   const [showPassword, setShowPassword] = useState(false);
//   const [showConfirmPassword, setShowConfirmPassword] = useState(false);
//   const [agreeTerms, setAgreeTerms] = useState(false);

//   const handleChange = (e) => {
//     setFormData({
//       ...formData,
//       [e.target.name]: e.target.value,
//     });
//   };

//   const validateForm = () => {
//     // Basic validation
//     if (
//       !formData.business_name.trim() ||
//       !formData.owner_name.trim() ||
//       !formData.email.trim() ||
//       !formData.mobile.trim() ||
//       !formData.password.trim()
//     ) {
//       toast.error("Please fill all required fields");
//       return false;
//     }

//     // Email validation
//     const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
//     if (!emailRegex.test(formData.email)) {
//       toast.error("Please enter a valid email address");
//       return false;
//     }

//     // Mobile validation
//     const mobileRegex = /^[0-9]{10}$/;
//     if (!mobileRegex.test(formData.mobile)) {
//       toast.error("Please enter a valid 10-digit mobile number");
//       return false;
//     }

//     // Password validation
//     if (formData.password.length < 6) {
//       toast.error("Password must be at least 6 characters long");
//       return false;
//     }

//     if (formData.password !== formData.confirm_password) {
//       toast.error("Passwords do not match");
//       return false;
//     }

//     // GST validation (optional)
//     if (formData.gst_number && formData.gst_number.length !== 15) {
//       toast.error("GST number must be 15 characters long");
//       return false;
//     }

//     // PAN validation (optional)
//     if (formData.pan_number) {
//       const panRegex = /^[A-Z]{5}[0-9]{4}[A-Z]{1}$/;
//       if (!panRegex.test(formData.pan_number.toUpperCase())) {
//         toast.error("Please enter a valid PAN number");
//         return false;
//       }
//     }

//     // Terms agreement
//     if (!agreeTerms) {
//       toast.error("Please agree to Terms & Conditions");
//       return false;
//     }

//     return true;
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();

//     if (!validateForm()) {
//       return;
//     }

//     try {
//       const response = await axios.post(
//         "https://cyberathon.com/multivendor/index.php/Api/Seller_Controller/seller_registration",
//         formData,
//         {
//           headers: { "Content-Type": "application/json" },
//         }
//       );

//       console.log("Registration Response", response.data);

//       if (response.data.success === "1" || response.data.status === "true") {
//         toast.success("Registration successful! Please wait for admin approval.");
        
//         setTimeout(() => {
//           navigate("/seller-login");
//         }, 2000);
//       } else {
//         toast.error(response.data.message || "Registration failed. Please try again.");
//       }
//     } catch (err) {
//       console.error("Registration error:", err);
//       toast.error(
//         err.response?.data?.message || "Registration failed. Please try again."
//       );
//     }
//   };

//   return (
//     <div className="seller-registration-wrapper">
//       <div className="seller-registration-container">
//         <div className="seller-reg-header">
//           <Link to="/" className="seller-reg-logo">
//             <img src="/Gemini_Generated_Image_r0npy2r0npy2r0np.png" alt="Logo" />
//           </Link>
//           <h1>Become a Seller</h1>
//           <p>Start your journey with us and reach millions of customers</p>
//         </div>

//         <form onSubmit={handleSubmit} className="seller-reg-form">
//           {/* Business Information */}
//           <div className="form-section">
//             <h2 className="section-title">Business Information</h2>
            
//             <div className="form-row">
//               <div className="form-group">
//                 <label>
//                   Business Name <span className="required">*</span>
//                 </label>
//                 <input
//                   type="text"
//                   name="business_name"
//                   placeholder="Enter your business name"
//                   value={formData.business_name}
//                   onChange={handleChange}
//                   required
//                 />
//               </div>

//               <div className="form-group">
//                 <label>
//                   Business Type <span className="required">*</span>
//                 </label>
//                 <select
//                   name="business_type"
//                   value={formData.business_type}
//                   onChange={handleChange}
//                   required
//                 >
//                   <option value="individual">Individual</option>
//                   <option value="proprietorship">Proprietorship</option>
//                   <option value="partnership">Partnership</option>
//                   <option value="company">Private Limited Company</option>
//                   <option value="llp">LLP</option>
//                 </select>
//               </div>
//             </div>

//             <div className="form-row">
//               <div className="form-group">
//                 <label>GST Number (Optional)</label>
//                 <input
//                   type="text"
//                   name="gst_number"
//                   placeholder="e.g., 22AAAAA0000A1Z5"
//                   value={formData.gst_number}
//                   onChange={handleChange}
//                   maxLength="15"
//                 />
//               </div>

//               <div className="form-group">
//                 <label>PAN Number (Optional)</label>
//                 <input
//                   type="text"
//                   name="pan_number"
//                   placeholder="e.g., ABCDE1234F"
//                   value={formData.pan_number}
//                   onChange={handleChange}
//                   maxLength="10"
//                   style={{ textTransform: "uppercase" }}
//                 />
//               </div>
//             </div>

//             <div className="form-row">
//               <div className="form-group">
//                 <label>Company website</label>
//                 <input
//                   type="text"
//                   name="pan_number"
//                   placeholder="Company Website"
//                   value={formData.pan_number}
//                   onChange={handleChange}
//                   maxLength="10"
//                   style={{ textTransform: "uppercase" }}
//                 />
//               </div>

//               <div className="form-group">
//                 <label>Brand Name</label>
//                 <input
//                   type="text"
//                   name="pan_number"
//                   placeholder="Brand Name"
//                   value={formData.pan_number}
//                   onChange={handleChange}
//                   maxLength="10"
//                   style={{ textTransform: "uppercase" }}
//                 />
//               </div>
//             </div>

//             <div className="form-row">
//               <div className="form-group">
//                 <label>
//                   Is brand already selling by others?
//                   <span className="required">*</span>
//                 </label>

//                 <div className="radio-group">
//                   <label className="radio-option">
//                     <input
//                       type="radio"
//                       name="brand_selling"
//                       value="yes"
//                       checked={formData.brand_selling === "yes"}
//                       onChange={handleChange}
//                       required
//                     />
//                     <span>Yes</span>
//                   </label>

//                   <label className="radio-option">
//                     <input
//                       type="radio"
//                       name="brand_selling"
//                       value="no"
//                       checked={formData.brand_selling === "no"}
//                       onChange={handleChange}
//                     />
//                     <span>No</span>
//                   </label>
//                 </div>
//               </div>

//               <div className="form-group">
//                 <label>GST Document upload</label>
//                 <input
//                   type="file"
//                   name="pan_number"
//                   placeholder="Brand Name"
//                   value={formData.pan_number}
//                   onChange={handleChange}
//                   maxLength="11"
//                 />
//               </div>
//             </div>

//             <div className="radio-group">
//               <div className="form-group">
//                 <label>Cancle check Upload</label>
//                 <input
//                   type="file"
//                   name="pan_number"
//                   placeholder="Brand Name"
//                   value={formData.pan_number}
//                   onChange={handleChange}
//                   maxLength="11"
//                 />
//               </div>

//               <div className="form-group">
//                 <label>Trademark Certificate Upload</label>
//                 <input
//                   type="file"
//                   name="pan_number"
//                   placeholder="Brand Name"
//                   value={formData.pan_number}
//                   onChange={handleChange}
//                   maxLength="11"
//                 />
//               </div>
//             </div>


//             <div className="form-group">
//               <label>
//                 Business Category <span className="required">*</span>
//               </label>
//               <select
//                 name="category"
//                 value={formData.category}
//                 onChange={handleChange}
//                 required
//               >
//                 <option value="">Select Category</option>
//                 <option value="electronics">Electronics</option>
//                 <option value="fashion">Fashion</option>
//                 <option value="home">Home & Furniture</option>
//                 <option value="beauty">Beauty & Personal Care</option>
//                 <option value="sports">Sports & Fitness</option>
//                 <option value="books">Books & Stationery</option>
//                 <option value="toys">Toys & Games</option>
//                 <option value="grocery">Grocery & Food</option>
//                 <option value="other">Other</option>
//               </select>
//             </div>
//           </div>

//           {/* Owner Information */}
//           <div className="form-section">
//             <h2 className="section-title">Owner/Contact Information</h2>
            
//             <div className="form-row">
//               <div className="form-group">
//                 <label>
//                   Owner Name <span className="required">*</span>
//                 </label>
//                 <input
//                   type="text"
//                   name="owner_name"
//                   placeholder="Enter owner's full name"
//                   value={formData.owner_name}
//                   onChange={handleChange}
//                   required
//                 />
//               </div>

//               <div className="form-group">
//                 <label>
//                   Email Address <span className="required">*</span>
//                 </label>
//                 <input
//                   type="email"
//                   name="email"
//                   placeholder="your@email.com"
//                   value={formData.email}
//                   onChange={handleChange}
//                   required
//                 />
//               </div>
//             </div>

//             <div className="form-row">
//               <div className="form-group">
//                 <label>
//                   Mobile Number <span className="required">*</span>
//                 </label>
//                 <input
//                   type="tel"
//                   name="mobile"
//                   placeholder="Enter 10-digit mobile number"
//                   value={formData.mobile}
//                   onChange={handleChange}
//                   maxLength="10"
//                   required
//                 />
//               </div>

//               <div className="form-group">
//                 <label>
//                   Password <span className="required">*</span>
//                 </label>
//                 <div className="password-input-wrapper">
//                   <input
//                     type={showPassword ? "text" : "password"}
//                     name="password"
//                     placeholder="Create a strong password"
//                     value={formData.password}
//                     onChange={handleChange}
//                     required
//                   />
//                   <button
//                     type="button"
//                     className="password-toggle"
//                     onClick={() => setShowPassword(!showPassword)}
//                   >
//                     {showPassword ? "👁️" : "👁️‍🗨️"}
//                   </button>
//                 </div>
//               </div>
//             </div>

//             <div className="form-group">
//               <label>
//                 Confirm Password <span className="required">*</span>
//               </label>
//               <div className="password-input-wrapper">
//                 <input
//                   type={showConfirmPassword ? "text" : "password"}
//                   name="confirm_password"
//                   placeholder="Re-enter your password"
//                   value={formData.confirm_password}
//                   onChange={handleChange}
//                   required
//                 />
//                 <button
//                   type="button"
//                   className="password-toggle"
//                   onClick={() => setShowConfirmPassword(!showConfirmPassword)}
//                 >
//                   {showConfirmPassword ? "👁️" : "👁️‍🗨️"}
//                 </button>
//               </div>
//             </div>
//           </div>

//           {/* Business Address */}
//           <div className="form-section">
//             <h2 className="section-title">Business Address</h2>
            
//             <div className="form-group">
//               <label>
//                 Address <span className="required">*</span>
//               </label>
//               <textarea
//                 name="address"
//                 placeholder="Enter complete business address"
//                 value={formData.address}
//                 onChange={handleChange}
//                 rows="3"
//                 required
//               />
//             </div>

//             <div className="form-row">
//               <div className="form-group">
//                 <label>
//                   City <span className="required">*</span>
//                 </label>
//                 <input
//                   type="text"
//                   name="city"
//                   placeholder="Enter city"
//                   value={formData.city}
//                   onChange={handleChange}
//                   required
//                 />
//               </div>

//               <div className="form-group">
//                 <label>
//                   State <span className="required">*</span>
//                 </label>
//                 <input
//                   type="text"
//                   name="state"
//                   placeholder="Enter state"
//                   value={formData.state}
//                   onChange={handleChange}
//                   required
//                 />
//               </div>

//               <div className="form-group">
//                 <label>
//                   Pincode <span className="required">*</span>
//                 </label>
//                 <input
//                   type="text"
//                   name="pincode"
//                   placeholder="Enter pincode"
//                   value={formData.pincode}
//                   onChange={handleChange}
//                   maxLength="6"
//                   required
//                 />
//               </div>
//             </div>
//           </div>

//           {/* Bank Details */}
//           <div className="form-section">
//             <h2 className="section-title">Bank Account Details</h2>
            
//             <div className="form-group">
//               <label>
//                 Account Holder Name <span className="required">*</span>
//               </label>
//               <input
//                 type="text"
//                 name="bank_account_holder"
//                 placeholder="Enter account holder name"
//                 value={formData.bank_account_holder}
//                 onChange={handleChange}
//                 required
//               />
//             </div>

//             <div className="form-row">
//               <div className="form-group">
//                 <label>
//                   Account Number <span className="required">*</span>
//                 </label>
//                 <input
//                   type="text"
//                   name="bank_account_number"
//                   placeholder="Enter bank account number"
//                   value={formData.bank_account_number}
//                   onChange={handleChange}
//                   required
//                 />
//               </div>

//               <div className="form-group">
//                 <label>
//                   IFSC Code <span className="required">*</span>
//                 </label>
//                 <input
//                   type="text"
//                   name="bank_ifsc_code"
//                   placeholder="e.g., SBIN0001234"
//                   value={formData.bank_ifsc_code}
//                   onChange={handleChange}
//                   maxLength="11"
//                   style={{ textTransform: "uppercase" }}
//                   required
//                 />
//               </div>
//             </div>

//             <div className="form-group">
//               <label>
//                 How did you hear about Garshys?
//               </label>
//               <textarea
//                 type="text"
//                 name="bank_account_holder"
//                 placeholder=""
//                 value={formData.bank_account_holder}
//                 onChange={handleChange}
//                 required
//               />
//             </div>
//           </div>

//           {/* Terms & Conditions */}
//           <div className="form-section">
//             <div className="checkbox-group">
//               <input
//                 type="checkbox"
//                 id="agreeTerms"
//                 checked={agreeTerms}
//                 onChange={(e) => setAgreeTerms(e.target.checked)}
//               />
//               <label htmlFor="agreeTerms">
//                 I agree to the{" "}
//                 <Link to="/seller-terms" target="_blank">
//                   Terms & Conditions
//                 </Link>{" "}
//                 and{" "}
//                 <Link to="/privacy-policy" target="_blank">
//                   Privacy Policy
//                 </Link>
//               </label>
//             </div>
//           </div>

//           <button type="submit" className="seller-submit-btn">
//             Register as Seller
//           </button>

//           <p className="login-link">
//             Already have a seller account?{" "}
//             <Link to="/seller-login">Login here</Link>
//           </p>
//         </form>
//       </div>

//       <ToastContainer />
//     </div>
//   );
// };

// export default SellerRegistration;


import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import axios from "axios";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const SellerRegistration = () => {
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [agreeTerms, setAgreeTerms] = useState(false);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const [formData, setFormData] = useState({
    role: "seller",
    business_name: "",
    owner_name: "",
    email: "",
    mobile: "",
    password: "",
    confirm_password: "",
    gst_number: "",
    pan_number: "",
    company_website: "",
    brand_name: "",
    brand_selling: "",
    address: "",
    street: "",
    landmark: "",
    city: "",
    state: "",
    pincode: "",
    vacation_mode: "no",
    account_number: "",
    ifsc_code: "",
    account_holder_name: "",
    bank_name: "",
    business_type: "Individual",
    business_category: "",
    heard_about_us: "",
    shop_name: "",
    shop_description: "",
    about_shop: "",
    gst_document: null,
    cancel_cheque_document: null,
    trademark_certificate: null,
    shop_banner: null,
    shop_logo: null,
  });

  const handleChange = (e) => {
    const { name, value, type, files } = e.target;
    
    if (type === "file") {
      setFormData({ ...formData, [name]: files[0] });
    } else {
      setFormData({ ...formData, [name]: value });
    }
  };

  const validateForm = () => {
    // Basic validation
    if (
      !formData.business_name.trim() ||
      !formData.owner_name.trim() ||
      !formData.email.trim() ||
      !formData.mobile.trim() ||
      !formData.password.trim()
    ) {
      toast.error("Please fill all required fields");
      return false;
    }

    // Email validation
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(formData.email)) {
      toast.error("Please enter a valid email address");
      return false;
    }

    // Mobile validation
    const mobileRegex = /^[0-9]{10}$/;
    if (!mobileRegex.test(formData.mobile)) {
      toast.error("Please enter a valid 10-digit mobile number");
      return false;
    }

    // Password validation
    if (formData.password.length < 6) {
      toast.error("Password must be at least 6 characters long");
      return false;
    }

    if (formData.password !== formData.confirm_password) {
      toast.error("Passwords do not match");
      return false;
    }

    // GST validation (optional)
    if (formData.gst_number && formData.gst_number.length !== 15) {
      toast.error("GST number must be 15 characters long");
      return false;
    }

    // Bank details validation - if any field is filled, all required fields must be filled
    const hasBankData = formData.account_holder_name || formData.account_number || 
                        formData.bank_name || formData.ifsc_code;
    
    if (hasBankData) {
      if (!formData.account_holder_name.trim()) {
        toast.error("Account Holder Name is required when adding bank details");
        return false;
      }
      if (!formData.account_number.trim()) {
        toast.error("Account Number is required when adding bank details");
        return false;
      }
      if (!formData.ifsc_code.trim()) {
        toast.error("IFSC Code is required when adding bank details");
        return false;
      }
    }

    // Terms agreement
    if (!agreeTerms) {
      toast.error("Please agree to Terms & Conditions");
      return false;
    }

    return true;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!validateForm()) {
      return;
    }

    setLoading(true);

    try {
      // Step 1: Main Seller Registration
      const formDataToSend = new FormData();
      
      // Append all text fields for main registration
      formDataToSend.append("role", "seller");
      formDataToSend.append("business_name", formData.business_name);
      formDataToSend.append("business_type", formData.business_type);
      formDataToSend.append("gst_number", formData.gst_number || "");
      formDataToSend.append("pan_number", formData.pan_number || "");
      formDataToSend.append("company_website", formData.company_website || "");
      formDataToSend.append("brand_name", formData.brand_name || "");
      formDataToSend.append("brand_selling_by_others", formData.brand_selling || "No");
      formDataToSend.append("business_category", formData.business_category);
      formDataToSend.append("owner_name", formData.owner_name);
      formDataToSend.append("email", formData.email);
      formDataToSend.append("mobile", formData.mobile);
      formDataToSend.append("password", formData.password);
      formDataToSend.append("address", formData.address);
      formDataToSend.append("landmark", formData.landmark || "");
      formDataToSend.append("city", formData.city);
      formDataToSend.append("state", formData.state);
      formDataToSend.append("pincode", formData.pincode);
      formDataToSend.append("heard_about_us", formData.heard_about_us || "");
      formDataToSend.append("terms_accepted", agreeTerms ? "1" : "0");

      // Append files if they exist
      if (formData.gst_document) {
        formDataToSend.append("gst_document", formData.gst_document);
      }
      if (formData.cancel_cheque_document) {
        formDataToSend.append("cancel_cheque_document", formData.cancel_cheque_document);
      }
      if (formData.trademark_certificate) {
        formDataToSend.append("trademark_certificate", formData.trademark_certificate);
      }

      const mainResponse = await axios.post(
        "https://cyberathon.com/multivendor/index.php/Api/Master_controller/add_seller_registration",
        formDataToSend,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );

      if (mainResponse.data.status === "true") {
        toast.success("Seller registration successful!");
        
        const sellerId = String(mainResponse.data.seller_id || "").trim();

        console.log("✅ Seller ID received from registration:", sellerId);

        // Step 2: Add Seller Address (RAW JSON)
        if (sellerId !== "") {
          try {
            await new Promise(resolve => setTimeout(resolve, 300));

            const addressPayload = {
              seller_id: String(sellerId),
              address: formData.address,
              street: formData.street || "",
              city: formData.city,
              pincode: formData.pincode,
              state: formData.state,
              landmark: formData.landmark || "",
              vacation_mode: "yes"
            };

            const addressResponse = await axios.post(
              "https://cyberathon.com/multivendor/index.php/Api/Master_controller/add_seller_address",
              addressPayload,
              { 
                headers: { 
                  "Content-Type": "application/json" 
                } 
              }
            );

            console.log("Address response:", addressResponse.data);

            if (addressResponse.data.status) {
              toast.success("Business address added successfully");
            }
          } catch (err) {
            console.error("Address error:", err);
            toast.warning("Seller registered, but address addition failed");
          }
        }

        // Step 3: Add Bank Details (RAW JSON)
        if (
            sellerId !== "" &&
            formData.account_number?.trim() &&
            formData.ifsc_code?.trim()
          ) {
            try {
              await new Promise(resolve => setTimeout(resolve, 300));

              const bankPayload = {
                seller_id: String(sellerId),
                account_number: formData.account_number,
                bank_name: formData.bank_name || "",
                account_holder_name: formData.account_holder_name,
                ifsc_code: formData.ifsc_code
              };

              const bankResponse = await axios.post(
                "https://cyberathon.com/multivendor/index.php/Api/Master_controller/add_bank_statement",
                bankPayload,
                { 
                  headers: { 
                    "Content-Type": "application/json" 
                  } 
                }
              );

              console.log("Bank response:", bankResponse.data);

              if (bankResponse.data.status) {
                toast.success("Bank details added successfully");
              }
            } catch (err) {
              console.error("Bank error:", err);
              toast.warning("Seller registered, but bank details failed");
            }
          }

        // Step 4: Add Shop Profile (if shop details are provided)
        if (formData.shop_name && sellerId) {
          try {
            const shopData = new FormData();
            shopData.append("seller_id", sellerId);
            shopData.append("shop_name", formData.shop_name);
            shopData.append("shop_description", formData.shop_description || "");
            shopData.append("about_shop", formData.about_shop || "");

            if (formData.shop_banner) {
              shopData.append("shop_banner_url", formData.shop_banner);
            }
            if (formData.shop_logo) {
              shopData.append("shop_logo_url", formData.shop_logo);
            }

            const shopResponse = await axios.post(
              "https://cyberathon.com/multivendor/index.php/Api/Master_controller/add_shop_profile",
              shopData,
              { headers: { "Content-Type": "multipart/form-data" } }
            );

            console.log("Shop response:", shopResponse.data);

            if (shopResponse.data.status === true) {
              toast.success("Shop profile created successfully!");
            }
          } catch (err) {
            console.error("Shop error:", err);
            toast.warning("Seller created, but shop profile failed.");
          }
        }

        // Navigate after all operations
        setTimeout(() => {
          navigate("/seller-login");
        }, 2000);
      } else {
        toast.error(mainResponse.data.message || "Registration failed");
      }
    } catch (error) {
      console.error("Registration error:", error);
      toast.error(error.response?.data?.message || "Something went wrong. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="container-fluid signin-section">
      <div id="signupbox" className="col-xl-8">
        <div className="loginbody">
          <div className="loginheader">
            Become a seller <span id="smallheader">Create Account</span>
          </div>

          <form onSubmit={handleSubmit} className="seller-reg-form">
            {/* Business Information */}
            <div className="form-section">
              <h2 className="section-title">Business Information</h2>
              
              <div className="form-row">
                <div className="form-group">
                  <label>
                    Business Name <span className="required">*</span>
                  </label>
                  <input
                    type="text"
                    name="business_name"
                    placeholder="Enter your business name"
                    value={formData.business_name}
                    onChange={handleChange}
                    required
                  />
                </div>

                <div className="form-group">
                  <label>
                    Business Type <span className="required">*</span>
                  </label>
                  <select
                    name="business_type"
                    value={formData.business_type}
                    onChange={handleChange}
                    required
                  >
                    <option value="Individual">Individual</option>
                    <option value="Proprietorship">Proprietorship</option>
                    <option value="Partnership">Partnership</option>
                    <option value="Private Limited Company">Private Limited Company</option>
                    <option value="LLP">LLP</option>
                  </select>
                </div>
              </div>

              <div className="form-row">
                <div className="form-group">
                  <label>GST Number (Optional)</label>
                  <input
                    type="text"
                    name="gst_number"
                    placeholder="e.g., 22AAAAA0000A1Z5"
                    value={formData.gst_number}
                    onChange={handleChange}
                    maxLength="15"
                  />
                </div>

                <div className="form-group">
                  <label>PAN Number (Optional)</label>
                  <input
                    type="text"
                    name="pan_number"
                    placeholder="e.g., ABCDE1234F"
                    value={formData.pan_number}
                    onChange={handleChange}
                    maxLength="10"
                    style={{ textTransform: "uppercase" }}
                  />
                </div>
              </div>

              <div className="form-row">
                <div className="form-group">
                  <label>Company Website</label>
                  <input
                    type="text"
                    name="company_website"
                    placeholder="Company Website"
                    value={formData.company_website}
                    onChange={handleChange}
                  />
                </div>

                <div className="form-group">
                  <label>Brand Name</label>
                  <input
                    type="text"
                    name="brand_name"
                    placeholder="Brand Name"
                    value={formData.brand_name}
                    onChange={handleChange}
                  />
                </div>
              </div>

              <div className="form-row">
                <div className="form-group">
                  <label>
                    Is brand already selling by others?
                    <span className="required">*</span>
                  </label>

                  <div className="radio-group ps-5">
                    <label className="radio-option">
                      <input
                        type="radio"
                        name="brand_selling"
                        value="Yes"
                        checked={formData.brand_selling === "Yes"}
                        onChange={handleChange}
                        required
                      />
                      <span>Yes</span>
                    </label>

                    <label className="radio-option">
                      <input
                        type="radio"
                        name="brand_selling"
                        value="No"
                        checked={formData.brand_selling === "No"}
                        onChange={handleChange}
                      />
                      <span>No</span>
                    </label>
                  </div>
                </div>

                <div className="form-group">
                  <label>GST Document Upload(Only PDF)</label>
                  <input
                    type="file"
                    name="gst_document"
                    onChange={handleChange}
                    accept=".pdf"
                  />
                </div>
              </div>

              <div className="form-row">
                <div className="form-group">
                  <label>Cancel Cheque Upload(Only PNG)</label>
                  <input
                    type="file"
                    name="cancel_cheque_document"
                    onChange={handleChange}
                    accept=".png"
                  />
                </div>

                <div className="form-group">
                  <label>Trademark Certificate Upload(Only PDF)</label>
                  <input
                    type="file"
                    name="trademark_certificate"
                    onChange={handleChange}
                    accept=".pdf"
                  />
                </div>
              </div>

              <div className="form-group">
                <label>
                  Business Category <span className="required">*</span>
                </label>
                <select
                  name="business_category"
                  value={formData.business_category}
                  onChange={handleChange}
                  required
                >
                  <option value="">Select Category</option>
                  <option value="electronics">Electronics</option>
                  <option value="fashion">Fashion</option>
                  <option value="home">Home & Furniture</option>
                  <option value="beauty">Beauty & Personal Care</option>
                  <option value="sports">Sports & Fitness</option>
                  <option value="books">Books & Stationery</option>
                  <option value="toys">Toys & Games</option>
                  <option value="grocery">Grocery & Food</option>
                  <option value="other">Other</option>
                </select>
              </div>
            </div>

            {/* Owner Information */}
            <div className="form-section">
              <h2 className="section-title">Owner/Contact Information</h2>
              
              <div className="form-row">
                <div className="form-group">
                  <label>
                    Owner Name <span className="required">*</span>
                  </label>
                  <input
                    type="text"
                    name="owner_name"
                    placeholder="Enter owner's full name"
                    value={formData.owner_name}
                    onChange={handleChange}
                    required
                  />
                </div>

                <div className="form-group">
                  <label>
                    Email Address <span className="required">*</span>
                  </label>
                  <input
                    type="email"
                    name="email"
                    placeholder="your@email.com"
                    value={formData.email}
                    onChange={handleChange}
                    required
                  />
                </div>
              </div>

              <div className="form-row">
                <div className="form-group">
                  <label>
                    Mobile Number <span className="required">*</span>
                  </label>
                  <input
                    type="tel"
                    name="mobile"
                    placeholder="Enter 10-digit mobile number"
                    value={formData.mobile}
                    onChange={handleChange}
                    maxLength="10"
                    required
                  />
                </div>

                <div className="form-group">
                  <label>
                    Password <span className="required">*</span>
                  </label>
                  <div className="password-input-wrapper">
                    <input
                      type={showPassword ? "text" : "password"}
                      name="password"
                      placeholder="Create a strong password"
                      value={formData.password}
                      onChange={handleChange}
                      required
                    />
                    <button
                      type="button"
                      className="password-toggle"
                      onClick={() => setShowPassword(!showPassword)}
                    >
                      {showPassword ? "👁️" : "👁️‍🗨️"}
                    </button>
                  </div>
                </div>
              </div>

              <div className="form-group">
                <label>
                  Confirm Password <span className="required">*</span>
                </label>
                <div className="password-input-wrapper">
                  <input
                    type={showConfirmPassword ? "text" : "password"}
                    name="confirm_password"
                    placeholder="Re-enter your password"
                    value={formData.confirm_password}
                    onChange={handleChange}
                    required
                  />
                  <button
                    type="button"
                    className="password-toggle"
                    onClick={() => setShowConfirmPassword(!showConfirmPassword)}
                  >
                    {showConfirmPassword ? "👁️" : "👁️‍🗨️"}
                  </button>
                </div>
              </div>
            </div>

            {/* Business Address */}
            <div className="form-section">
              <h2 className="section-title">Business Address</h2>
              
              <div className="form-group">
                <label>
                  Address <span className="required">*</span>
                </label>
                <textarea
                  name="address"
                  placeholder="Enter complete business address"
                  value={formData.address}
                  onChange={handleChange}
                  rows="3"
                  required
                />
              </div>

              <div className="form-group">
                <label>Street</label>
                <input
                  type="text"
                  name="street"
                  placeholder="Enter street name"
                  value={formData.street}
                  onChange={handleChange}
                />
              </div>

              <div className="form-group">
                <label>Landmark</label>
                <input
                  type="text"
                  name="landmark"
                  placeholder="Enter landmark"
                  value={formData.landmark}
                  onChange={handleChange}
                />
              </div>

              <div className="form-row">
                <div className="form-group">
                  <label>
                    City <span className="required">*</span>
                  </label>
                  <input
                    type="text"
                    name="city"
                    placeholder="Enter city"
                    value={formData.city}
                    onChange={handleChange}
                    required
                  />
                </div>

                <div className="form-group">
                  <label>
                    State <span className="required">*</span>
                  </label>
                  <input
                    type="text"
                    name="state"
                    placeholder="Enter state"
                    value={formData.state}
                    onChange={handleChange}
                    required
                  />
                </div>

                <div className="form-group">
                  <label>
                    Pincode <span className="required">*</span>
                  </label>
                  <input
                    type="text"
                    name="pincode"
                    placeholder="Enter pincode"
                    value={formData.pincode}
                    onChange={handleChange}
                    maxLength="6"
                    required
                  />
                </div>
              </div>
            </div>

            {/* Shop Profile Section */}
            <div className="form-section">
              <h2 className="section-title">Shop Profile (Optional)</h2>
              
              <div className="form-group">
                <label>Shop Name</label>
                <input
                  type="text"
                  name="shop_name"
                  placeholder="Enter your shop name"
                  value={formData.shop_name}
                  onChange={handleChange}
                />
              </div>

              <div className="form-group">
                <label>Shop Description</label>
                <textarea
                  name="shop_description"
                  placeholder="Brief description of your shop"
                  value={formData.shop_description}
                  onChange={handleChange}
                  rows="3"
                />
              </div>

              <div className="form-group">
                <label>About Shop</label>
                <textarea
                  name="about_shop"
                  placeholder="Tell customers more about your shop"
                  value={formData.about_shop}
                  onChange={handleChange}
                  rows="3"
                />
              </div>

              <div className="form-row">
                <div className="form-group">
                  <label>Shop Banner Upload</label>
                  <input
                    type="file"
                    name="shop_banner"
                    onChange={handleChange}
                    accept=".jpg,.jpeg,.png"
                  />
                </div>

                <div className="form-group">
                  <label>Shop Logo Upload</label>
                  <input
                    type="file"
                    name="shop_logo"
                    onChange={handleChange}
                    accept=".jpg,.jpeg,.png"
                  />
                </div>
              </div>
            </div>

            {/* Bank Details */}
            <div className="form-section">
              <h2 className="section-title">Bank Account Details (Optional)</h2>
              <p style={{ fontSize: "14px", color: "#666", marginBottom: "15px" }}>
                Leave blank to skip, or fill all required fields to add bank details
              </p>
              
              <div className="form-row">
              <div className="form-group">
                <label>
                  Account Holder Name
                  {(formData.account_number || formData.bank_name || formData.ifsc_code) && 
                    <span className="required">*</span>
                  }
                </label>
                <input
                  type="text"
                  name="account_holder_name"
                  placeholder="Enter account holder name"
                  value={formData.account_holder_name}
                  onChange={handleChange}
                />
              </div>

              <div className="form-group">
                  <label>
                    Account Number
                    {(formData.account_holder_name || formData.bank_name || formData.ifsc_code) && 
                      <span className="required">*</span>
                    }
                  </label>
                  <input
                    type="text"
                    name="account_number"
                    placeholder="Enter bank account number"
                    value={formData.account_number}
                    onChange={handleChange}
                  />
                </div>
                </div>

              <div className="form-row">
                <div className="form-group">
                <label>
                  Bank Type <span className="required">*</span>
                </label>
                <select
                  name="bank_type"
                  value={formData.bank_type}
                  onChange={handleChange}
                  required
                >
                  <option value="">Select Category</option>
                  <option value="saving">Saving Account</option>
                  <option value="current">Current Account</option>
                </select>
              </div>

                <div className="form-group">
                  <label>Bank Name</label>
                  <input
                    type="text"
                    name="bank_name"
                    placeholder="Enter bank name"
                    value={formData.bank_name}
                    onChange={handleChange}
                  />
                </div>
              </div>

              <div className="form-row">
                <div className="form-group">
                  <label>Bank Branch Name</label>
                  <input
                    type="text"
                    name="branch_name"
                    placeholder="Enter bank branch name"
                    value={formData.branch_name}
                    onChange={handleChange}
                  />
                </div>

                 <div className="form-group">
                <label>
                  IFSC Code
                  {(formData.account_holder_name || formData.account_number || formData.bank_name) && 
                    <span className="required">*</span>
                  }
                </label>
                <input
                  type="text"
                  name="ifsc_code"
                  placeholder="e.g., SBIN0001234"
                  value={formData.ifsc_code}
                  onChange={handleChange}
                  maxLength="11"
                  style={{ textTransform: "uppercase" }}
                />
              </div>
              </div>

              <div className="form-group">
                <label>How did you hear about Garshys?</label>
                <textarea
                  name="heard_about_us"
                  placeholder="Tell us how you found us"
                  value={formData.heard_about_us}
                  onChange={handleChange}
                  rows="3"
                />
              </div>
            </div>

            {/* Terms & Conditions */}
            <div className="form-section">
              <div className="checkbox-group">
                <input
                  type="checkbox"
                  id="agreeTerms"
                  checked={agreeTerms}
                  onChange={(e) => setAgreeTerms(e.target.checked)}
                />
                <label htmlFor="agreeTerms">
                  I agree to the{" "}
                  <Link to="/seller-terms" target="_blank">
                    Terms & Conditions
                  </Link>{" "}
                  and{" "}
                  <Link to="/privacy-policy" target="_blank">
                    Privacy Policy
                  </Link>
                </label>
              </div>
            </div>

            <button type="submit" className="seller-submit-btn" disabled={loading}>
              {loading ? "Registering..." : "Register as Seller"}
            </button>

            <p className="login-link">
              Already have a seller account?{" "}
              <Link to="/seller-login">Login here</Link>
            </p>
          </form>
        </div>
      </div>

      <ToastContainer />
    </div>
  );
};

export default SellerRegistration;